import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=0d56c3c8&scoped=true&"
import script from "./Calendar.vue?vue&type=script&lang=js&"
export * from "./Calendar.vue?vue&type=script&lang=js&"
import style0 from "./Calendar.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Calendar.vue?vue&type=style&index=1&id=0d56c3c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d56c3c8",
  null
  
)

export default component.exports